import React, {useState, useEffect} from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import Copy from './Copy';
import "./index.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import axios from "./../../../axios";
import Checkbox from "@material-ui/core/Checkbox";
import { blue } from "@material-ui/core/colors";
import { fetchTableChildren } from '../../../components/IFormDesignerLayout/RequestLogic';
import { mappingExistOrNot, removeMapping } from '../../../components/IFormDesignerLayout/RequestLogic';
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import styles from "./TreeMapFileCustom.module.css";
import RedCross from "../../../Icons/RedCross";
import {useDispatch,addContexts,useSelector} from "../../../Redux";
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from '../../../utils/secureSessionStorage';
 
const Tree = ({ data = [], elementType, selectedMappedValue, setParentChildCustom, setSelectedMappedValue, customServiceIds, setcustomServiceIds }) => {

    return (
        <div className='d-tree' 
          style={{maxHeight: "80% ", overflowY:"auto"}}
        >
            <ul className='d-flex d-tree-container flex-column'>
                {
                   data && data.length > 0  && data.map(tree=>(
                        <TreeNode node={tree}  elementType={elementType} 
                        selectedMappedValue={selectedMappedValue}
                        setParentChildCustom={setParentChildCustom}
                        setSelectedMappedValue={setSelectedMappedValue}
                        customServiceIds={customServiceIds}
                        setcustomServiceIds={setcustomServiceIds}
                        /> 
                    ))
                }
            </ul>
        </div>
    )
}

 const GreenCheckbox = withStyles({
        root: {
        color: green[400],
        "&$checked": {
            color: green[600],
        },
        },
        checked: {},
    })((props) => <Checkbox color="default" {...props} />);
  
    const BlueCheckbox = withStyles({
    root: {
        color: blue[400],
        "&$checked": {
        color: blue[600],
        },
    },
    checked: {},
    })((props) => <Checkbox color="default" {...props} />);


const TreeNode = ({node, elementType, selectedMappedValue, setParentChildCustom, setSelectedMappedValue, customServiceIds, setcustomServiceIds }) =>{
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
    const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
    var jwtToken = launchpadKey || undefined;
    
    const [childVisible, setChildVisiblity] = useState(false);
    const [selectedMapValue, setSelectedMapValue] = useState("");

    const hasChild =  (node["Unbounded"]==="Y" || node["children"]?.length > 0)  ? true : false

    function expandData(node){
            // console.log("node Data Is ", node);
            // node.children=[{label: 'Document-aaaaa'},{label: 'Document-vbbbb'}]
    }

     function fetchingChildrenMapped2(dataC){

        // console.log("nodeDataIsnodeDataIs ", dataC);
        // console.log("nodeDataIsnodeDataIs ", childVisible);

        if(childVisible===false && dataC.isMapped===true)
        {
        // setChildVisiblity(!childVisible);
        // setShowMapButton(false);    

        var currName=dataC.VariableName;
        var pName=(dataC?.parentName ?  dataC?.parentName + "." : "");

        var parentname= pName + currName;

        // var jsonToSend={"tableName":parentname,
        // "tableid":dataC.VariableId};
        // console.log("content.data content.data table def ",);

        fetch("/mdm-rest/app/gettabledefinition",{  
            method: "post",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
                "id": dataC.VariableId,
                "name": parentname,
                "status": "1"
            
            }),
  
           }).then(function(response) {
            return response.json();
          }).then(function(content) {
              
              // console.log("content.datacontent.datatable123 ", content);

              var data=JSON.stringify(content.data);

              // console.log("content.datacontent.datatable123 ", data);

              axios.post('/idesign/gettableDefinition',  {data},{withCredentials:true})     
              .then((response) => {
                  // console.log("content.datacontent.datatable123 ", response.data);
                  // console.log("content.datacontent.datatable123 ", response.data.children);

                  var childArray=[];

                  Object.values(response.data.children).map(child=>{
                      child.VariableName=child.SystemDefinedName;
                      childArray.push(child);
                  })

                  // console.log("content.datacontent.datatable123 ", childArray);

                dataC.children=response.data.children;


                // console.log("content.datacontent.datatable123 ", dataC);
                setRenderInstant(dataC);
                

              }).catch(function (error) {
                  if (error.response) {
                  }
                //   alert(error);
                console.log("error is", error)
              });
             
          })
          .catch((err)=>{
              console.log("error is", err)
           })

        }

     }
    function fetchingChildrenMapped(data){
    
            setChildVisiblity(!childVisible);
            // setShowMapButton(false);
    
            var jsonToSend={"tableName":data,
            "tableid":data.VariableId};
  
            // fetchTableChildren(jsonToSend).then((response)=>{
               
            //     // console.log("data after expanding the data Object ", response.data["children"]);
    
            //     data.children=response.data["children"];
            //      setRenderInstant(data);
             
            // })

            fetch("/mdm-rest/app/dataobjects",{  
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": jwtToken,
                },
                body: JSON.stringify({
                    
                  "category_id": "9",
                  "type": "C",
                  "sort_order": "A",
                  "order_by": "1",
                  "records_to_fetch": "30"
                
                }),
      
               }).then(function(response) {
                return response.json();
              }).then(function(content) {
                  
                  // console.log("content.data content.data ", content.data.data_objects);
                 
              })
              .catch((err)=>{
                  console.log("error is", err)
               })

     
           }
    const [renderInstant, setRenderInstant] = useState();


   function fetchingChildren(event, dataC){
        setChildVisiblity(!childVisible);
        var ab=1;
        if(childVisible===false && ab === 0 ) 
        {
        var currName=dataC.VariableName;
        var pName=(dataC?.parentName ?  dataC?.parentName + "." : "");
        var parentname= pName + currName;
        var jsonToSend={"tableName":parentname,
        "tableid":dataC.VariableId};

        fetch("/mdm-rest/app/gettabledefinition",{  
            method: "post",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
                
                "id": dataC.VariableId,
                "name": parentname,
                "status": "1"
            
            }),
  
           }).then(function(response) {
            return response.json();
          }).then(function(content) {
              var data=JSON.stringify(content.data);
              axios.post('/idesign/gettableDefinition',  {data},{withCredentials:true})     
              .then((response) => {
                  var childArray=[];

                  Object.values(response.data.children).map(child=>{
                      child.VariableName=child.SystemDefinedName;
                      childArray.push(child);
                  })
                dataC.children=response.data.children;
                setRenderInstant(dataC);
              }).catch(function (error) {
                  if (error.response) {
                  }
                console.log("error is", error)
              });
             
          })
          .catch((err)=>{
              console.log("error is", err)
           })

        }
        
       }

// const fetchingAllDataObjects = async (dataC) => {
//         setChildVisiblity(!childVisible);
//         var ab = 1;
//         if (
//           ab === 1 &&
//           childVisible === false &&
//           dataC.children === undefined &&
//           dataC.MappingInfo
//         ) {
//         window.loading(true)
//         const parentname = dataC?.VariableName
    
//         const jsonData = {
//           parentTableId: dataC ? (dataC?.VariableId ? dataC?.VariableId : "") : "",
//           treeName: parentname || "",
//           status: "1",
//           formId: getFormId().toString()
//         }
    
//         await axios
//         .post("/idesign/gettableDefinition", jsonData, {
//           withCredentials: true,
//         })
//         .then((response) => {
//           dataC.children = response.data.children;
//           setRenderInstant(dataC);
//         })
//         .catch((error) => {
//           if(error.response){
//             console.log("error", error.response)
//           }
//           console.log("error", error)
//         })
//         window.loading(false)
//       }
//     }

    // function setMappingOnControl(event, data){

    //     // console.log("setMappingOnControl ", data);


    //     var currName=data.VariableName;
    //     var pName=(data?.parentName ?  data?.parentName + "." : "");

    //     var parentname= pName + currName;

    //     var jsonToSend={"mappedField":parentname,"unbounded":data.Unbounded};
 
    //     mappingExistOrNot(jsonToSend).then((response)=>{
    //         // console.log("setMappingOnControl ", response.data);
    //         if(response.data.status==="-1"){
    //             // console.log("yes yes yes yes yes yes 1");
    //         }
    //         if(response.data.status==="0"){
    //             // console.log("yes yes yes yes yes yes 2");
    //             // console.log("mappingControlsMapSave  ", parentname);
    //             // console.log("mappingdatamappingdata  ", data);
    //             // console.log("mappingdatamappingdata ", dataObjectsContent.children);

    //             // data.isMapped=true;
    //             Object.values(dataObjectsContent.children).map(parentData=>{
    //                 if(parentData.SystemDefinedName ===  data.parentName){
    //                     parentData.isMapped=true;
    //                 }
    //             })

    //             // console.log("mappingdatamappingdata ", dataObjectsContent.children);

    //             setMapValue(parentname);
    //             setMapId(data.VariableId);
    //             setShowMapButton(false);
    //         }
    //     })
    //     event.stopPropagation();
    // } 

    function JsonUnMapButtonParent(event, data){

        // var currName=data.VariableName;
        // var pName=(data?.parentName ?  data?.parentName + "." : "");

        // var parentname= pName + currName;

        // var jsonToSend={"mappedField":parentname,"unbounded":data.Unbounded};
 
        // removeMapping(jsonToSend).then((response)=>{
        //     // console.log("setMappingOnControl ", response.data);
        //     if(response.data.status==="-1"){
        //         // console.log("yes yes yes yes yes yes 1");
        //     }
        //     if(response.data.status==="0"){
        //         // console.log("yes yes yes yes yes yes 2");
        //         // console.log("mappingControlsMapSaveUnMap  ", parentname);
        //         // console.log("mappingControlsMapSaveUnMap  ", data);
        //         setMapValue("");
        //         setMapId();
        //         setShowMapButton(false);
        //     }
        // })
        // event.stopPropagation();


    }  

    function setMapButton(event, data){

         // console.log("selectedMapValue12Data ", data);

         if(data["Unbounded"] === "Y"){
            setParentChildCustom("parent");
         }else{
            setParentChildCustom("child");
         }

         var mappedSet = new Set();

        //  mappedSet.add(data["VariableName"]);

        //  var unmappedSet = new Set();

         customServiceIds.forEach(function(value){
           mappedSet.add(value);
         })
         

         setcustomServiceIds(mappedSet);

        //    setMapId(data["VariableName"]);

            // setParentChildCustom 
        //   selectedMappedValue(data["VariableName"])

        //if(customServiceIds.has(data["VariableName"])){
            // customServiceIds.add(data["VariableName"]);
        //}

          setSelectedMappedValue(data["treeName"])

        //    setMapId(data["ParentName"]);
    
        //    setSelectedMapValue(data["VariableName"])

        //    setShowMapButton(!showMapButton);
           event.stopPropagation();
       }



       var inputStyleForParent={
           backgroundColor: "#0072C619"
       }

       var inputStyle={

       }

    return (
        // <li className='d-tree-node border-0'>
        
            <li className={styles.parentChild}   >
                <div className={`${styles.centerAlign} d-flex`}  
                
                // style={showMapButton ? inputStyleForParent : inputStyle } 
                
                // style={node["VariableName"] === selectedMapValue  ? inputStyleForParent : inputStyle }

            //    style={node["VariableName"] === MapId ? inputStyleForParent : inputStyle }

                // style={node["ParentName"]  === MapId ? inputStyleForParent : inputStyle }    

                style={node["treeName"]  === selectedMappedValue ? inputStyleForParent : inputStyle }   

                // onClick={e => setChildVisiblity(v => !v)} 
                 onClick={(event)=>fetchingChildren(event, node)}
                // onClick={()=>setRenderInstant(node)}
                
                
                >
                    {
                        hasChild && (
                            // <div className={`d-inline d-tree-toggler ${childVisible ? "active" : ""} `}>
                             //     {/* <FontAwesomeIcon icon="caret-right" /> */}
                            //     {/* <Copy/> */}
                            //     $
                            // </div>
                            <div>
                                {childVisible ? <span className={styles.iconStyle}   ><ExpandMoreIcon/></span>: 
                                <span   
                                className={styles.iconStyle} 
                                // onClick={(event)=>fetchingChildren(event, node)}
                                >
                                <ChevronRightIcon/></span> }
                                &nbsp;
                                </div>
                        )
                    }

                    {!hasChild ? <>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;</> : null}

                 
                    {customServiceIds.has(node["treeName"]) ?
                          <span style={translationStyles1?{marginRight:"-9px"}:{marginLeft:"-9px"}}>
                          <BlueCheckbox
                              icon={<FiberManualRecordOutlinedIcon style={{ fontSize: "13px", color: "black",marginTop:"-3px"}} />}
                              checkedIcon={<FiberManualRecordIcon style={{ fontSize: "13px", }}/>}
                             //  checked={true}
                           checked={true}
                          />
                        </span>
                        :
                        <span style={translationStyles1?{marginRight:"-9px"}:{marginLeft:"-9px"}}>
                        <BlueCheckbox
                            icon={<FiberManualRecordOutlinedIcon style={{ fontSize: "13px", color: "black",marginTop:"-3px"}} />}
                            checkedIcon={<FiberManualRecordIcon style={{ fontSize: "13px", }}/>}
                           //  checked={true}
                         checked={false}
                        />
                      </span>
                    } 




                        {/* <GreenCheckbox/> */}

                    {/* <div className='col d-tree-head' //  onClick={()=>expandData(node)} //  onClick={(event)=>fetchingChildren(event, node)}
                     >
                        {node["VariableName"]}
                    </div> */}

                    <span  
                        className={node["Unbounded"] ==="Y" ? styles.parentNameStyle : styles.variableNameStyle }
                        style={translationStyles1?{marginLeft:"unset",marginRight:"4px"}:null}
                        title={node["VariableName"]}
                        onClick={(event)=>setMapButton(event,node)}
                    > 
                        {node["VariableName"]}  
                    </span>

                    &nbsp;
                    
                    {/* {!hasChild ? 
                    <>
                    <span 
                    // style={{marginTop:"3px"}}
                    className={styles.variableTypeClass}
                    > ( {node["VariableType"]} )</span>
                    </> : null} */}

                    {/* {showMapButton ?  <button className={styles.mapButtonStyle}
                       onClick={(event)=>setMappingOnControl(event,node)}
                    > Map </button> : null} */}


                    {/* {(MapId === node["VariableId"])  ?  
                     <>
                     <span 
                     className={styles.unMapButtonStyle}
                      onClick={(event)=>JsonUnMapButtonParent(event, node)}
                       > UnMap &nbsp; <RedCross/> </span>
                       </>
                       : null    
                } */}

                    </div>

                    {
                        hasChild && childVisible && <div className='d-tree-content'>
                                    <ul className='d-flex d-tree-container flex-column'>
                                        <Tree data={node.children}
                                         elementType={elementType}
                                         selectedMappedValue={selectedMappedValue}
                                         setParentChildCustom={setParentChildCustom}
                                         setSelectedMappedValue={setSelectedMappedValue}
                                         customServiceIds={customServiceIds}
                                         setcustomServiceIds={setcustomServiceIds}
                                        />
                                    </ul>
                             </div>
                    }

             
        </li>
    )


}



export default Tree